import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
  },
  textField: {
    width: '100%',
  },
  arrowIconStandard: {
    position: 'absolute',
    right: -3,
    top: 10,
  },
  crossIconStandard: {
    position: 'absolute',
    right: -1,
    top: 10,
  },
  arrowIconOutlined: {
    position: 'absolute',
    right: 5,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  crossIconOutlined: {
    position: 'absolute',
    right: 7,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}));
